module.exports = __webpack_public_path__ + "img/member_center_footer_435001.2f3624d1.png";